// src/index.js
import React, { useContext, useMemo } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import App from "./App";

import { MoodProvider, MoodContext } from "./app/MoodContext";
import { DailyMoodProvider, DailyMoodContext } from "./features/mood/DailyMoodContext";
import { AuthProvider } from "./context/auth";
import { ThemeConfigProvider, useThemeConfig } from "./context/themeConfig";
import { SiteConfigProvider } from "./context/siteConfig";
import { createAppTheme } from "./theme/theme";

function ThemeGate({ children }) {
  const { mood } = useContext(MoodContext);
  const { moodId: dailyMoodId } = useContext(DailyMoodContext);
  const themeConfig = useThemeConfig();
  const theme = useMemo(
    () => createAppTheme(dailyMoodId || mood, themeConfig),
    [dailyMoodId, mood, themeConfig]
  );
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <AuthProvider>
        <SiteConfigProvider>
          <ThemeConfigProvider>
            <DailyMoodProvider>
              <MoodProvider>
                <ThemeGate>
                  <CssBaseline />
                  <App />
                </ThemeGate>
              </MoodProvider>
            </DailyMoodProvider>
          </ThemeConfigProvider>
        </SiteConfigProvider>
      </AuthProvider>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
// StrictMode は dev の二重マウントで Firestore watch stream が
// "INTERNAL ASSERTION FAILED (ID: ca9/b815)" を踏むため外している
// （firebase.js の long-polling 対策と合わせた措置。本番挙動には影響なし）
root.render(<RouterProvider router={router} />);
